var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.87,
    height: 20.308,
    viewBox: "0 0 21.87 20.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15699",
    "data-name": "Group 15699",
    transform: "translate(-9313 -715)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13795",
    "data-name": "Path 13795",
    d: "M29.5,20.91V13H23.254v7.91a.521.521,0,0,1-.377.5l-2.606.751L26.379,28.4l6.107-6.237L29.88,21.41A.521.521,0,0,1,29.5,20.91Z",
    transform: "translate(9297.557 702)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13797",
    "data-name": "Path 13797",
    d: "M31.829,44.645a.521.521,0,0,1-.521.521H12.562a.521.521,0,0,1-.521-.521V41H11v5.728H32.87V41H31.829Z",
    transform: "translate(9302 688.58)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewDownload);
export default __webpack_public_path__ + "static/media/preview_download.d785bd2b1eac90ac339f60d0a72bf73b.svg";
export { ForwardRef as ReactComponent };